import carousel from './freemode-carousel';

const imageCarousel = document.querySelector('.ImageCarousel-swiper');
if (imageCarousel) {
  carousel(imageCarousel, {
    loop: false,
    slidesPerView: 1.333,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    breakpoints: {
      768: {
        slidesPerView: 2.333,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
        slidesOffsetBefore: 165,
      },
    },
  });
}
